<div style="height: 100%; width: 100%; background-color: #017acd">
  <p-carousel #carousel [numVisible]="1" [style]="{height:'100%'}" [value]="slides" [circular]="false" [showNavigators]="false">
    <ng-template let-product #item>
        <ion-img tappable (click)="next($event, carousel)" [src]="product.image" style="width: 100%; height: 100%; object-fit:contain"></ion-img>
    </ng-template>
  </p-carousel>
</div>
